import React from "react";
import styled from "styled-components";
import { useEffect, useRef, useState } from "react";
import { Stage, Layer, Line, Text } from "react-konva";
import DrawingViewPanel from "./detailDrawingPanelComponent";
import DetailDrawView from "./dtailDrawView";
import API from "../../API/API";
import { Image } from "../common/image";
import { text } from "stream/consumers";
import SignatureModalComponent from "./signatureModalComponent";

const Wrapper = styled.div`
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
const Container = styled.div`
  padding: 2vw 1vw 1vw 1vw;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
`;
const Header = styled.div`
  width: 100%;
  height: 4vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const HeaderTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: end;
  font-weight: 800;
  font-size: 3vw;
  height: 4vw;
`;
const LogoImg = styled.div`
  width: 20vw;
  height: 6vw;
  padding-left: 1vw;
  display: flex;
  justify-content: start;
  align-items: end;
`;

const ContentArea = styled.div`
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const TopTable = styled.div`
  text-align: center;
  width: 100%;
  border-top: 0.16vw solid black;
  /* border-bottom: 0.16vw solid black; */
  height: 3.4vw;
  display: flex;
  align-items: center;
  justify-content: start;
`;
const TopTableTd = styled.div`
  text-align: center;
  width: 100%;
  /* border-top: 0.16vw solid black; */
  border-bottom: 0.16vw solid black;
  height: 3.4vw;
  margin-bottom: 1vw;
  display: flex;
  align-items: center;
  justify-content: start;
`;
const TopTr = styled.div<{
  width?: string;
  borderRight?: string;
  borderLeft?: string;
}>`
  border-right: ${(props) => (props.borderRight ? props.borderRight : "")};
  display: flex;
  align-items: center;
  justify-content: start;
`;
const TopTdTitle = styled.div<{
  $width?: string;
  $borderRight?: string;
  $borderLeft?: string;
}>`
  font-size: 1.3vw;
  background-color: #f4f4f4;
  width: 10vw;
  height: 100%;
  display: flex;
  align-items: center;
  font-weight: 600;
  justify-content: center;
`;

const TopTdTitle2 = styled.div<{
  $width?: string;
  $borderRight?: string;
  $borderLeft?: string;
}>`
  font-size: 1.3vw;
  background-color: #f4f4f4;
  width: 8vw;
  height: 100%;
  display: flex;
  align-items: center;
  font-weight: 600;
  justify-content: center;
`;

const TopTd = styled.div<{
  $width?: string;
  $borderRight?: string;
  $borderLeft?: string;
}>`
  font-size: 1.4vw;
  display: flex;
  font-weight: 700;
  align-items: center;
  justify-content: center;
  width: 13.3vw;
  height: 3.4vw;
  border-bottom: 0.1vw solid #e4e4e4;
  /* border-right: 0.1vw solid black; */
`;

const TopTd2 = styled.div<{
  $width?: string;
  $borderRight?: string;
  $borderLeft?: string;
}>`
  font-size: 1.3vw;
  display: flex;
  font-weight: 700;
  align-items: center;
  justify-content: center;
  width: 20vw;
  height: 3.4vw;
  border-bottom: 0.1vw solid #e4e4e4;
  /* border-right: 0.1vw solid black; */
`;

const ApplyInfoTable = styled.div`
  display: flex;
  text-align: center;
  font-size: 10vw;
  width: 100%;
  margin-bottom: 1vw;
`;

const ApplyInfoTable2 = styled.div`
  text-align: center;
  border-top: 0.16vw solid black;
  font-size: 1.3vw;
  width: 100%;
  margin-bottom: 1vw;
`;

const ApplyInfoTr = styled.div<{
  $width?: string;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0.1vw solid #e4e4e4;
`;

const WorkConditionBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  border-bottom: 0.1vw solid #e4e4e4;
`;

const ApplyInfoTdTitle = styled.div<{
  $width?: string;
  $borderRight?: string;
  $borderLeft?: string;
}>`
  background-color: #f4f4f4;
  width: ${(props) => (props.$width ? props.$width : "6.12vw")};
  height: 3.4vw;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 1.3vw;
  justify-content: center;
  border-right: ${(props) =>
    props.$borderRight ? props.$borderRight : "0.1vw solid #e4e4e4"};
  border-left: ${(props) => (props.$borderLeft ? props.$borderLeft : "")};
`;
const ApplyInfoTd = styled.div<{
  $width?: string;
  $borderRight?: string;
  $borderLeft?: string;
}>`
  width: ${(props) => (props.$width ? props.$width : "10vw")};
  display: flex;
  font-weight: 600;
  align-items: center;
  border-right: ${(props) => (props.$borderRight ? props.$borderRight : "")};
  justify-content: center;
  font-size: 1.4vw;
  height: 3.4vw;
`;
const MemoBox = styled.div`
  width: 43vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const TextMemoBox = styled.div`
  width: 100%;
  height: 5vw;
  border: 0.1vw solid #a1a1a1;
  background-color: #fafafa;
  border-radius: 0.4vw;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: start;
  padding: 1vw;
`;

const TextLine = styled.div`
  font-size: 1.3vw;
  margin-bottom: 0.2vw;
`;
const TextSpan1 = styled.span`
  color: black;
  font-size: 1.3vw;
  margin-bottom: 0.2vw;
`;
const TextSpan2 = styled.span`
  color: #ff7f3b;
  text-decoration: underline;
  font-size: 1.3vw;
  margin-bottom: 0.4vw;
`;

const MemoRound = styled.div`
  width: 41vw;
  height: 18vw;
  border: 0.1vw solid #a1a1a1;
  background-color: #fafafa;
  border-radius: 0.6vw;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 2vw;
  padding-left: 2vw;
  margin-top: 1vw;
`;

const TextMemoRound = styled.div`
  width: 100%;
  height: 50.2vw;
  border: 0.1vw solid #a1a1a1;
  background-color: #fafafa;
  border-radius: 0.6vw;
  display: flex;
  justify-content: start;
  align-items: start;
  padding: 1vw;
`;

const OptionBoxArea = styled.div`
  width: 100%;
  height: 10.8vw;
  display: flex;
  justify-content: center;
  border-top: 0.16vw solid black;
  border-left: 0.16vw solid black;
  margin-bottom: 0.6vw;
`;

const OptionBox = styled.div`
  width: 33.3%;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-size: 1.4vw;
  font-weight: 500;
  /* background-color: red; */
`;

const OptionItemBox = styled.div`
  width: 100%;
  height: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 0.1vw solid #a1a1a1;
`;

const OptionName = styled.div`
  width: 56%;
  height: 100%;
  background-color: #fafafa;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2vw;
  font-weight: 500;
  border-right: 0.1vw solid #a1a1a1;
`;

const OptionText = styled.div`
  width: 44%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2vw;
  font-weight: 500;
  background-color: #ffffff;
  border-right: 0.1vw solid #a1a1a1;
`;

// const TextMemoText = styled.pre`
//   font-size: 1.2vw;
//   font-weight: 300;
//   text-align: start;
//   line-height: 1.2vw;
//   color: #383838;
// `;
const TextMemoText = styled.pre`
  /* font-size: 1.6vw;
  line-height: 2vw; */
  font-size: 1.5vw;
  line-height: 1.6vw;
  font-weight: 500;
  text-align: start;
  color: #000000;
  white-space: pre-line; /* width 안에서 받아온 엔터 그대로 적용 될 수 있도록 처리 / 넘치면 아래로 내려감 */
  border: none;
  width: 100%; /* 원하는 너비 */
  height: 100%; /* 원하는 높이 */
  resize: none; /* 크기 조절 비활성화 */
  background-color: #fafafa;
  outline: none; /* 포커스 아웃라인 제거 */
  :read-only {
    background-color: #fafafa; /* 읽기 전용일 때 배경색 (선택 사항) */
  }
  overflow: hidden;
`;

const MemoRound2 = styled.div`
  width: 20vw;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const BottomComponent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 62.6vw;
`;
const PriceListArea = styled.div`
  width: 30vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: end;
`;

const PriceListBox = styled.div`
  width: 100%;
  border-top: 0.16vw solid black;
  border-left: 0.1vw solid black;
  margin-bottom: 0.4vw;
`;

const TotalPriceBox = styled.div`
  margin-top: 1vw;
  width: 100%;
  height: 3vw;
  display: flex;
  border-bottom: 0.16vw solid black;
  margin-bottom: 1vw;
`;

const TotalPriceName = styled.div`
  width: 46%;
  height: 100%;
  margin-bottom: 1vw;
  display: flex;
  align-items: center;
`;
const TotalPriceInput = styled.div`
  width: 54%;
  height: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
  margin-bottom: 1vw;
`;

const PriceNameInput = styled.p`
  text-align: start;
  font-size: 1.7vw;
  font-weight: 700;
`;

const PriceInput = styled.p`
  text-align: end;
  font-size: 1.8vw;
  font-weight: 700;
  width: 10vw;
`;

const PriceNameInputEng = styled.p`
  font-size: 1.3vw;
  font-weight: 500;
  padding-left: 0.4vw;
  padding-right: 0.8vw;
  padding-top: 0.6vw;
`;

const AgreementBox = styled.div`
  width: 100%;
  height: 4vw;
  display: flex;
  /* flex-direction: column; */
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.16vw solid black;
  /* background-color: gray; */
`;
const ImageBox = styled.div`
  margin-right: 1vw;
`;

const AgreementTextLine = styled.div`
  margin-top: 0.3vw;
  font-size: 1.6vw;
  line-height: 1.1vw;
  font-weight: 500;
  display: flex;
  text-align: start;
  justify-content: space-between;
  align-items: center;
`;

const SignatureBox = styled.div`
  width: 100%;
  height: 6.6vw;
  display: flex;
  justify-content: space-between;
  border-bottom: 0.16vw solid black;
  margin-top: 0.4vw;
`;

const SignatureTitle = styled.div`
  width: 30%;
`;

const SignatureArea = styled.div`
  width: 70%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.4vw;
`;

const PriceItemBox = styled.div`
  width: 100%;
  height: 3vw;
  display: flex;
`;
const PriceItemBox3 = styled.div`
  width: 100%;
  height: 3.8vw;
  display: flex;
  /* border-left: 0.1vw solid black;
  border-top: 0.1vw solid black; */
`;

const PriceItemBox2 = styled.div`
  width: 15.8vw;
  height: 3vw;
  display: flex;
`;

const OptionItemName = styled.div`
  width: 8.2vw;
  height: 3vw;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f4f4f4;
  font-size: 1.3vw;
  border-bottom: 0.1vw solid #b4b4b4;
  /* border-right: 0.1vw solid gray; */
`;

const OptionItem = styled.div`
  width: 8vw;
  height: 3vw;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.3vw;
  border-bottom: 0.1vw solid #b4b4b4;
  /* border-right: 0.1vw solid gray; */
`;

const OptionItem2 = styled.div`
  width: 8vw;
  height: 3vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.3vw;
  border-bottom: 0.1vw solid #b4b4b4;
`;

const OptionItemListBox = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`;

const PriceItemName = styled.div`
  width: 45%;
  height: 100%;
  font-weight: 600;
  background-color: #f4f4f4;
  display: flex;
  align-items: center;
  font-size: 1.3vw;
  padding-left: 1vw;
  border-bottom: 0.1vw solid #dbdbdb;
`;

const PriceItemPrice = styled.div`
  width: 55%;
  height: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
  padding-right: 1vw;
  border-bottom: 0.04vw solid #d3d3d3;
`;
const PriceItemName2 = styled.div`
  width: 45%;
  height: 100%;
  background-color: #f4f4f4;
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 1.6vw;

  padding-left: 1vw;
  border-bottom: 0.1vw solid #dbdbdb;
`;

const PriceItemPrice2 = styled.div`
  width: 55%;
  height: 100%;
  display: flex;
  font-weight: 700;
  justify-content: end;
  align-items: center;
  padding-right: 1vw;
  border-bottom: 0.04vw solid #d3d3d3;
`;
const Price = styled.p`
  font-size: 1.5vw;
  font-weight: 600;
  margin-right: 0.4vw;
`;
const Price2 = styled.p`
  font-size: 1.6vw;
  font-weight: 700;
  margin-right: 0.4vw;
`;
const Unit = styled.p`
  font-size: 1.3vw;
  font-weight: 300;
  padding-top: 0.3vw;
`;

const BottomLine = styled.div`
  margin-top: 0.8vw;
  width: 100%;
  border-top: 0.1vw solid black;
  margin-bottom: 0.4vw;
`;
const AgreeBox = styled.div`
  margin-top: 1vw;
  height: 10vw;
  width: 100%;
  display: flex;
  align-items: start;
  padding: 1vw;
  background-color: #f7f7f7;
  border-radius: 0.6vw;
`;
const AgreeCheckBox = styled.input`
  width: 1vw;
  height: 1vw;
  &:checked {
    background-color: #ff7f3b;
  }
`;

const FooterArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const FooterItemBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const FooterItem1 = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  font-size: 1vw;
  font-weight: 600;
`;

const FooterItem2 = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  font-size: 1vw;
  font-weight: 300;
`;

const FooterItem3 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: end;
  height: 3vw;
  font-size: 1.2vw;
  border: 0.1vw solid #ababab;
  background-color: #efefef3a;
  border-radius: 0.2vw;
  padding: 1vw 2vw;
`;

const Index = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 1vw;
  font-size: 1.2vw;
  font-weight: 300;
`;

const ServiceArea = styled.div`
  width: 100%;
  margin-bottom: 1vw;
  display: flex;
  justify-content: center;
  border-bottom: 0.04vw solid #e4e4e4;
  border-top: 0.16vw solid black;
`;

const ServiceBox = styled.div`
  width: 33.3%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const ServiceColumnBox = styled.div`
  width: 100%;
  height: 2.6vw;
  display: flex;
  font-size: 1.3vw;
  font-weight: 300;
`;

const ServiceName = styled.div`
  width: 10vw;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  background-color: #f4f4f4;
  /* border-left: 0.04vw solid black; */
  border-bottom: 0.04vw solid #e4e4e4;
`;

const ServiceDate = styled.div`
  width: 9vw;
  height: 100%;
  display: flex;
  font-weight: 600;
  justify-content: center;
  align-items: center;
  border-left: 0.04vw solid #e4e4e4;
  border-bottom: 0.04vw solid #e4e4e4;
`;

const ServicePrice = styled.div`
  width: 9vw;
  height: 100%;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: 0.04vw solid #e4e4e4;
  border-bottom: 0.04vw solid #e4e4e4;
`;

const ServicePaymentMethod = styled.div`
  width: 7vw;
  height: 100%;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: 0.04vw solid #e4e4e4;
  border-bottom: 0.04vw solid #e4e4e4;
`;
const SignatureNoneBox = styled.div`
  width: 18vw;
  height: 80%;
  outline: 0.3vw dashed #d0d0d0;
  border-radius: 0.5vw;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const SignatureNoneBoxText = styled.div`
  color: #d0d0d0;
  font-weight: 500;
  font-size: 2.4vw;
`;
// FirstPage 컴포넌트 정의
const FirstPage = (props: any) => {
  const {
    priceDataList,
    articleDataList,
    optionData,
    lines,
    reNum,
    drawingData,
    drawingData2,
    detailData,
    getDetailList,
    movingCBM,
    transitCBM,
    discardCBM,
    setLines,
    setLines2,
    lines2,
    setDrawingData,
    setDrawingData2,
    ladderTruckTotal,
    optionTotalCharge,
    setIsPreviewModalOpen,
    otherDateData,
    contractNum,
  } = props;

  const divRef = useRef<any>(null);
  const stageRef = useRef<any>(null);
  const divRef2 = useRef<any>(null);
  const stageRef2 = useRef<any>(null);
  const [dimensions, setDimensions] = useState<any>({
    width: 0,
    height: 0,
  });
  const [dimensions2, setDimensions2] = useState<any>({
    width: 0,
    height: 0,
  });
  const [tool, setTool] = useState<string>("pen");
  const [penColorVisible, setPenColorVisible] = useState<boolean>(false);
  const [penColor, setPenColor] = useState<any>();
  const [textMemo, setTextMemo] = useState<string>("");
  const [onSignatureModal, setOnSignatureModal] = useState<boolean>(false);
  const formattedDate = /^(\d{4})(\d{2})(\d{2})$/;
  const signatureModalVisible = () => {
    setOnSignatureModal(true);
  };
  const transportationMethodList = [
    { id: 0, status: "선택안함" },
    { id: 1, status: "사다리차" },
    { id: 2, status: "엘리베이터" },
    { id: 3, status: "계단" },
    { id: 4, status: "기타" },
  ];

  const paymentMethodList = [
    { id: 0, status: "선택안함" },
    { id: 1, status: "현금" },
    { id: 2, status: "온라인" },
    { id: 3, status: "카드" },
    { id: 4, status: "무빙팀 수금" },
    { id: 5, status: "리빙팀 수금" },
  ];

  const paymentMethodList2 = [
    { id: 0, status: "온라인" },
    { id: 1, status: "현금" },
    { id: 2, status: "카드" },
  ];

  const getDrawingData = async () => {
    const response = await API.get(`receipt/memo/${reNum}`);
    if (response.status === 200) {
      const result = response.data.receiptMemoData;
      const result2 = response.data.textMemo;
      setDrawingData(result);
      setTextMemo(result2);
    } else {
      alert("Fail to getDrawingData()");
    }
  };

  useEffect(() => {
    if (divRef.current?.offsetHeight && divRef.current?.offsetWidth) {
      setDimensions({
        width: divRef.current.offsetWidth - 2,
        height: divRef.current.offsetHeight - 2,
      });
    }
    if (divRef2.current?.offsetHeight && divRef2.current?.offsetWidth) {
      setDimensions2({
        width: divRef2.current.offsetWidth - 1,
        height: divRef2.current.offsetHeight - 1,
      });
    }
  }, []);

  useEffect(() => {
    getDrawingData();
    setPenColorVisible(true);
    setTool("pen");
    setPenColor("#000000");
  }, []);

  useEffect(() => {
    getDetailList();
  }, [onSignatureModal]);

  const [width, setWidth] = useState<any>(window.innerWidth);
  const [drawNum, setDrawNum] = useState<number>(0.1);
  const [signatureNum, setSignatureNum] = useState<number>(0.41);

  const handleResize = () => {
    setWidth(window.innerWidth);
    if (width < 300) {
      setSignatureNum(0.07);
      setDrawNum(0.1);
    } else if (width < 400) {
      setSignatureNum(0.06);
      setDrawNum(0.14);
    } else if (width < 400) {
      setSignatureNum(0.08);
      setDrawNum(0.16);
    } else if (width < 600) {
      setSignatureNum(0.08);
      setDrawNum(0.18);
    } else if (width < 700) {
      setSignatureNum(0.1);
      setDrawNum(0.26);
    } else if (width < 830) {
      setSignatureNum(0.12);
      setDrawNum(0.3);
    } else if (width < 915) {
      setSignatureNum(0.13);
      setDrawNum(0.3);
    } else if (width < 1050) {
      setSignatureNum(0.16);
      setDrawNum(0.41);
    } else {
      setSignatureNum(0.18);
      setDrawNum(0.43);
    }
  };
  useEffect(() => {
    setTimeout(() => {
      window.addEventListener("resize", handleResize);
      handleResize();
    }, 500);
    return () => {
      // cleanup
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    handleResize();
  }, [width]);
  return (
    <>
      {onSignatureModal && (
        <SignatureModalComponent
          setOnSignatureModal={setOnSignatureModal}
          setIsPreviewModalOpen={setIsPreviewModalOpen}
          getDetailList={getDetailList}
        />
      )}
      <Wrapper className="firstPageBox">
        <Container>
          <Header>
            <LogoImg>
              <Image
                src="/icon/tonginLogo.png"
                width={"70%"}
                height={"70%"}
              ></Image>
            </LogoImg>
            <HeaderTitle>계약서 • 견적서</HeaderTitle>
          </Header>
          <ContentArea>
            <TopTable>
              <TopTdTitle2>고객명</TopTdTitle2>
              <TopTd>{detailData.name}</TopTd>
              <TopTdTitle $borderLeft={"0.1vw solid black"}>
                이사종류
              </TopTdTitle>
              <TopTd2>{detailData.movingType}</TopTd2>
              <TopTdTitle $borderLeft={"0.1vw solid black"}>
                전화번호
              </TopTdTitle>
              <TopTd>{detailData.contact}</TopTd>
            </TopTable>
            <TopTableTd>
              <TopTdTitle2>담당자</TopTdTitle2>
              <TopTd>{detailData.planner.name}</TopTd>
              <TopTdTitle $borderLeft={"0.1vw solid black"}>지점명</TopTdTitle>
              <TopTd2>{detailData.branch.branchName}</TopTd2>
              <TopTdTitle $borderLeft={"0.1vw solid black"}>
                담당자 연락처
              </TopTdTitle>
              <TopTd>{detailData.planner.contact}</TopTd>
            </TopTableTd>

            <ApplyInfoTable2>
              <WorkConditionBox>
                <ApplyInfoTdTitle $width={"15%"}>이사 전 주소</ApplyInfoTdTitle>
                <ApplyInfoTd
                  $width={"60%"}
                  $borderRight={"0.1vw solid #e4e4e4"}
                >
                  {`${detailData.preAddress}, ${detailData.preAddressDetail}`}
                </ApplyInfoTd>
                <ApplyInfoTdTitle $width={"15%"}>
                  작업조건 (전)
                </ApplyInfoTdTitle>
                <ApplyInfoTd
                  $width={"14%"}
                  $borderRight={"0.1vw solid #e4e4e4"}
                >
                  {optionData.beforeWorkCondition.pyeong}(평)
                </ApplyInfoTd>
                <ApplyInfoTd $width={"15%"}>
                  {
                    transportationMethodList[
                      optionData.beforeWorkCondition.transportationMethod
                    ].status
                  }
                </ApplyInfoTd>
              </WorkConditionBox>
              <WorkConditionBox>
                <ApplyInfoTdTitle $width={"15%"}>이사 후 주소</ApplyInfoTdTitle>
                <ApplyInfoTd
                  $width={"60%"}
                  $borderRight={"0.1vw solid #e4e4e4"}
                >
                  {`${detailData.afterAddress}, ${detailData.afterAddressDetail}`}
                </ApplyInfoTd>
                <ApplyInfoTdTitle $width={"15%"}>
                  작업조건 (후)
                </ApplyInfoTdTitle>
                <ApplyInfoTd
                  $width={"14%"}
                  $borderRight={"0.1vw solid #e4e4e4"}
                >
                  {optionData.afterWorkCondition.pyeong}(평)
                </ApplyInfoTd>
                <ApplyInfoTd $width={"15%"}>
                  {
                    transportationMethodList[
                      optionData.afterWorkCondition.transportationMethod
                    ].status
                  }
                </ApplyInfoTd>
              </WorkConditionBox>
            </ApplyInfoTable2>

            <ApplyInfoTable2>
              <ApplyInfoTr>
                <ApplyInfoTdTitle>접수일</ApplyInfoTdTitle>
                <ApplyInfoTd>
                  {detailData.receptionDate === ""
                    ? "--"
                    : detailData.receptionDate.replace(
                        formattedDate,
                        "$1-$2-$3",
                      )}
                </ApplyInfoTd>
                <ApplyInfoTdTitle>상담일</ApplyInfoTdTitle>
                <ApplyInfoTd>
                  {detailData.consultationDate === ""
                    ? "--"
                    : detailData.consultationDate.replace(
                        formattedDate,
                        "$1-$2-$3",
                      )}
                </ApplyInfoTd>
                <ApplyInfoTdTitle>계약일</ApplyInfoTdTitle>
                <ApplyInfoTd>
                  {detailData.contractDate === "        "
                    ? otherDateData.fakeContractDate.replace(
                        formattedDate,
                        "$1-$2-$3",
                      )
                    : detailData.contractDate.replace(
                        formattedDate,
                        "$1-$2-$3",
                      )}
                </ApplyInfoTd>
                <ApplyInfoTdTitle>이사일</ApplyInfoTdTitle>
                <ApplyInfoTd>
                  {detailData.movingDate === ""
                    ? "--"
                    : detailData.movingDate.replace(formattedDate, "$1-$2-$3")}
                </ApplyInfoTd>
              </ApplyInfoTr>
              <ApplyInfoTr>
                <ApplyInfoTdTitle>포장일</ApplyInfoTdTitle>
                <ApplyInfoTd>
                  {otherDateData.packageDate === ""
                    ? "--"
                    : otherDateData.packageDate.replace(
                        formattedDate,
                        "$1-$2-$3",
                      )}
                </ApplyInfoTd>
                <ApplyInfoTdTitle>운반일</ApplyInfoTdTitle>
                <ApplyInfoTd>
                  {otherDateData.carryDate === ""
                    ? "--"
                    : otherDateData.carryDate.replace(
                        formattedDate,
                        "$1-$2-$3",
                      )}
                </ApplyInfoTd>
                <ApplyInfoTdTitle>청소일</ApplyInfoTdTitle>
                <ApplyInfoTd>
                  {otherDateData.cleanDate === ""
                    ? "--"
                    : otherDateData.cleanDate.replace(
                        formattedDate,
                        "$1-$2-$3",
                      )}
                </ApplyInfoTd>
                <ApplyInfoTdTitle></ApplyInfoTdTitle>
                <ApplyInfoTd></ApplyInfoTd>
              </ApplyInfoTr>
            </ApplyInfoTable2>

            <ServiceArea>
              <ServiceBox>
                <ServiceColumnBox>
                  <ServiceName>입주청소서비스</ServiceName>
                  <ServiceDate>
                    {optionData.livingService.movingCleaningService.selected
                      ? optionData.livingService.movingCleaningService
                          .serviceRequestDate === ""
                        ? "--"
                        : `${optionData.livingService.movingCleaningService.serviceRequestDate.substring(
                            2,
                            4,
                          )}-${optionData.livingService.movingCleaningService.serviceRequestDate.substring(
                            4,
                            6,
                          )}-${optionData.livingService.movingCleaningService.serviceRequestDate.substring(
                            6,
                            8,
                          )}`
                      : "-"}
                  </ServiceDate>
                  <ServicePaymentMethod>
                    {optionData.livingService.movingCleaningService.selected
                      ? paymentMethodList[
                          optionData.livingService.movingCleaningService
                            .paymentMethod
                        ].status
                      : "-"}
                  </ServicePaymentMethod>
                </ServiceColumnBox>
                <ServiceColumnBox>
                  <ServiceName>정리수납서비스</ServiceName>
                  <ServiceDate>
                    {optionData.livingService.organizationStorageService
                      .selected
                      ? optionData.livingService.organizationStorageService
                          .serviceRequestDate === ""
                        ? "--"
                        : `${optionData.livingService.organizationStorageService.serviceRequestDate.substring(
                            2,
                            4,
                          )}-${optionData.livingService.organizationStorageService.serviceRequestDate.substring(
                            4,
                            6,
                          )}-${optionData.livingService.organizationStorageService.serviceRequestDate.substring(
                            6,
                            8,
                          )}`
                      : "-"}
                  </ServiceDate>
                  <ServicePaymentMethod>
                    {optionData.livingService.organizationStorageService
                      .selected
                      ? paymentMethodList[
                          optionData.livingService.organizationStorageService
                            .paymentMethod
                        ].status
                      : "-"}
                  </ServicePaymentMethod>
                </ServiceColumnBox>
              </ServiceBox>
              <ServiceBox>
                <ServiceColumnBox>
                  <ServiceName>가전청소서비스</ServiceName>
                  <ServiceDate>
                    {" "}
                    {optionData.livingService.electronicCleaningService.selected
                      ? optionData.livingService.electronicCleaningService
                          .serviceRequestDate === ""
                        ? "--"
                        : `${optionData.livingService.electronicCleaningService.serviceRequestDate.substring(
                            2,
                            4,
                          )}-${optionData.livingService.electronicCleaningService.serviceRequestDate.substring(
                            4,
                            6,
                          )}-${optionData.livingService.electronicCleaningService.serviceRequestDate.substring(
                            6,
                            8,
                          )}`
                      : "-"}
                  </ServiceDate>
                  <ServicePaymentMethod>
                    {optionData.livingService.electronicCleaningService.selected
                      ? paymentMethodList[
                          optionData.livingService.electronicCleaningService
                            .paymentMethod
                        ].status
                      : "-"}
                  </ServicePaymentMethod>
                </ServiceColumnBox>
                <ServiceColumnBox>
                  <ServiceName>탈취살균서비스</ServiceName>
                  <ServiceDate>
                    {" "}
                    {optionData.livingService.deodorizationService.selected
                      ? optionData.livingService.deodorizationService
                          .serviceRequestDate === ""
                        ? "--"
                        : `${optionData.livingService.deodorizationService.serviceRequestDate.substring(
                            2,
                            4,
                          )}-${optionData.livingService.deodorizationService.serviceRequestDate.substring(
                            4,
                            6,
                          )}-${optionData.livingService.deodorizationService.serviceRequestDate.substring(
                            6,
                            8,
                          )}`
                      : "-"}
                  </ServiceDate>
                  <ServicePaymentMethod>
                    {optionData.livingService.deodorizationService.selected
                      ? paymentMethodList[
                          optionData.livingService.deodorizationService
                            .paymentMethod
                        ].status
                      : "-"}
                  </ServicePaymentMethod>
                </ServiceColumnBox>
              </ServiceBox>
              <ServiceBox>
                <ServiceColumnBox>
                  <ServiceName>에이프런서비스</ServiceName>
                  <ServiceDate>
                    {optionData.livingService.apronService.selected
                      ? optionData.livingService.apronService
                          .serviceRequestDate === ""
                        ? "--"
                        : `${optionData.livingService.apronService.serviceRequestDate.substring(
                            2,
                            4,
                          )}-${optionData.livingService.apronService.serviceRequestDate.substring(
                            4,
                            6,
                          )}-${optionData.livingService.apronService.serviceRequestDate.substring(
                            6,
                            8,
                          )}`
                      : "-"}
                  </ServiceDate>
                  <ServicePaymentMethod>
                    {optionData.livingService.apronService.selected
                      ? paymentMethodList[
                          optionData.livingService.apronService.paymentMethod
                        ].status
                      : "-"}
                  </ServicePaymentMethod>
                </ServiceColumnBox>
                <ServiceColumnBox>
                  <ServiceName>무브제서비스</ServiceName>
                  <ServiceDate>
                    {optionData.livingService.movjetService.selected
                      ? optionData.livingService.movjetService
                          .serviceRequestDate === ""
                        ? "--"
                        : `${optionData.livingService.movjetService.serviceRequestDate.substring(
                            2,
                            4,
                          )}-${optionData.livingService.movjetService.serviceRequestDate.substring(
                            4,
                            6,
                          )}-${optionData.livingService.movjetService.serviceRequestDate.substring(
                            6,
                            8,
                          )}`
                      : "-"}
                  </ServiceDate>
                  <ServicePaymentMethod>
                    {optionData.livingService.movjetService.selected
                      ? paymentMethodList[
                          optionData.livingService.movjetService.paymentMethod
                        ].status
                      : "-"}
                  </ServicePaymentMethod>
                </ServiceColumnBox>
              </ServiceBox>
            </ServiceArea>

            <BottomComponent>
              <MemoBox>
                {/* 메모 영역 */}
                <TextMemoRound>
                  <TextMemoText>{textMemo}</TextMemoText>
                </TextMemoRound>
                {/* 메모 영역 */}
                <OptionBoxArea>
                  <OptionBox>
                    <OptionItemBox>
                      <OptionName>
                        {optionData.optionService.ServiceList[0].optionName}
                      </OptionName>
                      <OptionText>
                        {optionData.optionService.ServiceList[0].optionPayment.toLocaleString()}
                        {/* {optionData.optionService.ServiceList[0]
                          .decomposition &&
                        optionData.optionService.ServiceList[0].installation
                          ? "분해/설치"
                          : null}
                        {optionData.optionService.ServiceList[0]
                          .decomposition &&
                        !optionData.optionService.ServiceList[0].installation
                          ? "분해"
                          : null}
                        {!optionData.optionService.ServiceList[0]
                          .decomposition &&
                        optionData.optionService.ServiceList[0].installation
                          ? "설치"
                          : null}
                        {!optionData.optionService.ServiceList[0]
                          .decomposition &&
                        !optionData.optionService.ServiceList[0].installation
                          ? "-"
                          : null} */}
                      </OptionText>
                    </OptionItemBox>
                    <OptionItemBox>
                      <OptionName>
                        {optionData.optionService.ServiceList[1].optionName}
                      </OptionName>
                      <OptionText>
                        {optionData.optionService.ServiceList[1].optionPayment.toLocaleString()}
                      </OptionText>
                    </OptionItemBox>
                    <OptionItemBox>
                      <OptionName>
                        {optionData.optionService.ServiceList[2].optionName}
                      </OptionName>
                      <OptionText>
                        {optionData.optionService.ServiceList[2].optionPayment.toLocaleString()}
                      </OptionText>
                    </OptionItemBox>
                    <OptionItemBox>
                      <OptionName>
                        {optionData.optionService.ServiceList[3].optionName}
                      </OptionName>
                      <OptionText>
                        {optionData.optionService.ServiceList[3].optionPayment.toLocaleString()}
                      </OptionText>
                    </OptionItemBox>
                  </OptionBox>
                  <OptionBox>
                    <OptionItemBox>
                      <OptionName>
                        {optionData.optionService.ServiceList[4].optionName}
                      </OptionName>
                      <OptionText>
                        {optionData.optionService.ServiceList[4].optionPayment.toLocaleString()}
                      </OptionText>
                    </OptionItemBox>
                    <OptionItemBox>
                      <OptionName>
                        {optionData.optionService.ServiceList[5].optionName}
                      </OptionName>
                      <OptionText>
                        {optionData.optionService.ServiceList[5].optionPayment.toLocaleString()}
                      </OptionText>
                    </OptionItemBox>
                    <OptionItemBox>
                      <OptionName>
                        {optionData.optionService.ServiceList[6].optionName}
                      </OptionName>
                      <OptionText>
                        {optionData.optionService.ServiceList[6].optionPayment.toLocaleString()}
                      </OptionText>
                    </OptionItemBox>
                    <OptionItemBox>
                      <OptionName>
                        {optionData.optionService.ServiceList[7].optionName}
                      </OptionName>
                      <OptionText>
                        {optionData.optionService.ServiceList[7].optionPayment.toLocaleString()}
                      </OptionText>
                    </OptionItemBox>
                  </OptionBox>
                  <OptionBox>
                    <OptionItemBox>
                      <OptionName>
                        {optionData.optionService.ServiceList[8].optionName}
                      </OptionName>
                      <OptionText>
                        {optionData.optionService.ServiceList[8].optionPayment.toLocaleString()}
                      </OptionText>
                    </OptionItemBox>
                    <OptionItemBox>
                      <OptionName>
                        {optionData.optionService.ServiceList[9].optionName}
                      </OptionName>
                      <OptionText>
                        {optionData.optionService.ServiceList[9].optionPayment.toLocaleString()}
                      </OptionText>
                    </OptionItemBox>
                    <OptionItemBox>
                      <OptionName>
                        {optionData.optionService.ServiceList[10].optionName}
                      </OptionName>
                      <OptionText>
                        {optionData.optionService.ServiceList[10].optionPayment.toLocaleString()}
                      </OptionText>
                    </OptionItemBox>
                    <OptionItemBox>
                      <OptionName>옵션 합계</OptionName>
                      <OptionText>
                        {optionTotalCharge.toLocaleString()}
                      </OptionText>
                    </OptionItemBox>
                  </OptionBox>
                </OptionBoxArea>
              </MemoBox>
              <PriceListArea>
                <PriceListBox>
                  <PriceItemBox>
                    <PriceItemName>물량(운반/경유/폐기)</PriceItemName>
                    <PriceItemPrice>
                      <Price>{`${movingCBM}  / ${transitCBM} / ${discardCBM}`}</Price>
                      <Unit>cbm</Unit>
                    </PriceItemPrice>
                  </PriceItemBox>

                  <PriceItemBox>
                    <PriceItemName>이사비용</PriceItemName>
                    <PriceItemPrice>
                      <Price>{priceDataList[0].amount.toLocaleString()}</Price>
                      <Unit>₩</Unit>
                    </PriceItemPrice>
                  </PriceItemBox>

                  <PriceItemBox>
                    <PriceItemName>사다리차 비용</PriceItemName>
                    <PriceItemPrice>
                      <Price>{ladderTruckTotal.toLocaleString()}</Price>
                      <Unit>₩</Unit>
                    </PriceItemPrice>
                  </PriceItemBox>

                  <PriceItemBox>
                    <PriceItemName>옵션 비용</PriceItemName>
                    <PriceItemPrice>
                      <Price>{optionTotalCharge.toLocaleString()}</Price>
                      <Unit>₩</Unit>
                    </PriceItemPrice>
                  </PriceItemBox>

                  <PriceItemBox>
                    <PriceItemName>입주청소서비스</PriceItemName>
                    <PriceItemPrice>
                      <Price>
                        {optionData.livingService.movingCleaningService.servicePayment.toLocaleString()}
                      </Price>
                      <Unit>₩</Unit>
                    </PriceItemPrice>
                  </PriceItemBox>

                  <PriceItemBox>
                    <PriceItemName>정리수납서비스</PriceItemName>
                    <PriceItemPrice>
                      <Price>
                        {optionData.livingService.organizationStorageService.servicePayment.toLocaleString()}
                      </Price>
                      <Unit>₩</Unit>
                    </PriceItemPrice>
                  </PriceItemBox>

                  <PriceItemBox>
                    <PriceItemName>가전청소서비스</PriceItemName>
                    <PriceItemPrice>
                      <Price>
                        {optionData.livingService.electronicCleaningService.servicePayment.toLocaleString()}
                      </Price>
                      <Unit>₩</Unit>
                    </PriceItemPrice>
                  </PriceItemBox>

                  <PriceItemBox>
                    <PriceItemName>탈취살균서비스</PriceItemName>
                    <PriceItemPrice>
                      <Price>
                        {optionData.livingService.deodorizationService.servicePayment.toLocaleString()}
                      </Price>
                      <Unit>₩</Unit>
                    </PriceItemPrice>
                  </PriceItemBox>

                  <PriceItemBox>
                    <PriceItemName>에이프런서비스</PriceItemName>
                    <PriceItemPrice>
                      <Price>
                        {optionData.livingService.apronService.servicePayment.toLocaleString()}
                      </Price>
                      <Unit>₩</Unit>
                    </PriceItemPrice>
                  </PriceItemBox>

                  <PriceItemBox>
                    <PriceItemName>무브제서비스</PriceItemName>
                    <PriceItemPrice>
                      <Price>
                        {optionData.livingService.movjetService.servicePayment.toLocaleString()}
                      </Price>
                      <Unit>₩</Unit>
                    </PriceItemPrice>
                  </PriceItemBox>

                  <PriceItemBox>
                    <PriceItemName>
                      {optionData.livingService.otherService.description === ""
                        ? "기타서비스"
                        : optionData.livingService.otherService.description}
                    </PriceItemName>
                    <PriceItemPrice>
                      <Price>
                        {optionData.livingService.otherService.servicePayment.toLocaleString()}
                      </Price>
                      <Unit>₩</Unit>
                    </PriceItemPrice>
                  </PriceItemBox>

                  <PriceItemBox>
                    <PriceItemName>보관비용</PriceItemName>
                    <PriceItemPrice>
                      <Price>{priceDataList[1].amount.toLocaleString()}</Price>
                      <Unit>₩</Unit>
                    </PriceItemPrice>
                  </PriceItemBox>
                  <PriceItemBox>
                    <PriceItemName>부가세(VAT)</PriceItemName>
                    <PriceItemPrice>
                      <Price>
                        {priceDataList[2].amount.toLocaleString() === "0"
                          ? "부가세 별도"
                          : priceDataList[2].amount.toLocaleString()}
                      </Price>
                      <Unit>
                        {priceDataList[2].amount.toLocaleString() === "0"
                          ? ""
                          : "₩"}
                      </Unit>
                    </PriceItemPrice>
                  </PriceItemBox>
                  <PriceItemBox3>
                    <PriceItemName2>총 비용</PriceItemName2>
                    <PriceItemPrice2>
                      <Price2>
                        {priceDataList[3].amount.toLocaleString()}
                      </Price2>
                      <Unit>₩</Unit>
                    </PriceItemPrice2>
                  </PriceItemBox3>
                  <PriceItemBox3>
                    <PriceItemName2>
                      계약금(
                      {
                        paymentMethodList2[priceDataList[4].paymentMethod]
                          .status
                      }
                      )
                    </PriceItemName2>
                    <PriceItemPrice2>
                      <Price2>
                        {priceDataList[4].amount.toLocaleString()}
                      </Price2>
                      <Unit>₩</Unit>
                    </PriceItemPrice2>
                  </PriceItemBox3>
                  <PriceItemBox3>
                    <PriceItemName2>
                      잔금(
                      {
                        paymentMethodList2[priceDataList[5].paymentMethod]
                          .status
                      }
                      )
                    </PriceItemName2>
                    <PriceItemPrice2>
                      <Price2>
                        {priceDataList[5].amount.toLocaleString()}
                      </Price2>
                      <Unit>₩</Unit>
                    </PriceItemPrice2>
                  </PriceItemBox3>
                </PriceListBox>
                {/* <TotalPriceBox>
                  <TotalPriceName>
                    <PriceNameInput>총 비용</PriceNameInput>
                    <PriceNameInputEng>(VAT별도)</PriceNameInputEng>
                  </TotalPriceName>
                  <TotalPriceInput>
                    <PriceInput>
                      {priceDataList[3].amount.toLocaleString()}
                    </PriceInput>
                    <PriceNameInputEng>₩</PriceNameInputEng>
                  </TotalPriceInput>
                </TotalPriceBox> */}
                <AgreementBox>
                  <AgreementTextLine>
                    이용약관 및 개인정보 수집/활용 동의
                  </AgreementTextLine>
                  <AgreementTextLine>
                    <ImageBox>
                      <Image
                        src={`/icon/${
                          detailData.pushYN ? "checked" : "unchecked"
                        }.png`}
                        width={"1.6vw"}
                        height={"1.6vw"}
                      ></Image>
                    </ImageBox>
                  </AgreementTextLine>
                </AgreementBox>
                <SignatureBox>
                  <SignatureTitle>
                    <PriceNameInput>고객서명</PriceNameInput>
                  </SignatureTitle>
                  <SignatureArea>
                    {!detailData.pushYN ? (
                      <SignatureNoneBox onClick={() => signatureModalVisible()}>
                        <SignatureNoneBoxText>서명하기</SignatureNoneBoxText>
                      </SignatureNoneBox>
                    ) : (
                      <>
                        <MemoRound2 ref={divRef2} id={"CanvasPanel2"}>
                          <Stage
                            width={dimensions2.width}
                            height={dimensions2.height}
                            ref={stageRef2}
                            stroke={""}
                          >
                            <Layer>
                              {lines2.map((line: any, i: any) => (
                                <Line
                                  key={i}
                                  points={line.points.map(
                                    (point: number) => point * signatureNum,
                                  )}
                                  stroke={line.stroke}
                                  strokeWidth={1}
                                  tension={0.8}
                                  lineCap="round"
                                  globalCompositeOperation={
                                    line.tool === "eraser"
                                      ? "destination-out"
                                      : "source-over"
                                  }
                                />
                              ))}
                            </Layer>
                          </Stage>
                        </MemoRound2>
                      </>
                    )}
                  </SignatureArea>
                </SignatureBox>
              </PriceListArea>
            </BottomComponent>
          </ContentArea>
          <FooterArea>
            {/* <BottomLine></BottomLine> */}
            <FooterItemBox>
              <FooterItem1>www.tonginexp.com</FooterItem1>
              <FooterItem2>고객센터: 1899-0123</FooterItem2>
              <FooterItem2>본사: 02-3678-0123</FooterItem2>
              <FooterItem2>서울시 서초구 양재동 263-2, 통인빌딩</FooterItem2>
              <FooterItem3>
                <div>SERIAL NO.</div>
                <div>{reNum}</div>
              </FooterItem3>
            </FooterItemBox>
            <Index>- 1 -</Index>
          </FooterArea>
        </Container>
      </Wrapper>
    </>
  );
};
export default FirstPage;
